var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-interface-close-button",attrs:{"aria-label":"close"},on:{"click":_vm.close}},[_c('img',{staticClass:"c-interface-close-button__icon",attrs:{"src":_vm.source}})])
}
var staticRenderFns = []

export { render, staticRenderFns }